import React from 'react'
import BreadcrumbTab from '../../../../common/BreadcrumbTab'
import RMASuccess from '../../RMASuccess'
import { RMADetailBox1, RMADetailBox2 } from '../../style/RMA.css'
import { DoneReturnBoxWMO, ReturnConfirmationHeading } from '../../style/RMAWMO.css'
import useWmoEnabled from '@usap/carparts/src/shared/hooks/useWmoEnabled'

const DoneReturn = ({ moduleData }) => {
  const {
    isDesktop,
    tabData,
    cancelReturn,
    orderDetails,
    OpenChatHandler,
  } = { ...moduleData }

  const isWmoEnabled = useWmoEnabled()

  if(isWmoEnabled) {
    return (
      <DoneReturnBoxWMO>
        <ReturnConfirmationHeading>
          Return Confirmation
        </ReturnConfirmationHeading>
        <RMASuccess
          key="confirmationRMA"
          isDesktop={isDesktop}
          handleDone={cancelReturn}
          orderDetails={orderDetails}
          OpenChatHandler={OpenChatHandler}
        />
      </DoneReturnBoxWMO>
    )
  }

  return (
    <RMADetailBox1>
      <RMADetailBox2>
        <BreadcrumbTab
          key="breadcrumbTabSuccess"
          data={tabData}
          bgColor="#a3a3a3"
          bgActiveColor="#333"
          activeStep={1}
        />
        <RMASuccess
          key="confirmationRMA"
          isDesktop={isDesktop}
          handleDone={cancelReturn}
          orderDetails={orderDetails}
          OpenChatHandler={OpenChatHandler}
        />
      </RMADetailBox2>
    </RMADetailBox1>
  )
}

export default DoneReturn
